module.exports = __webpack_public_path__ + "media/images/lb/824-2d336bcef34fd48884121955c7473d03.svg";